import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  assetCount: number
  busy: boolean
  onCancel: () => void
  onRemoveNodeOnly: () => void
  onRemoveNodeAndAssets: () => void
}

export default function CanvasVideoNodeDeleteModal({
  open,
  assetCount,
  busy,
  onCancel,
  onRemoveNodeOnly,
  onRemoveNodeAndAssets,
}: Props) {
  const { t } = useTranslation('canvas')

  return (
    <Modal
      open={open}
      title={t('board.deleteVideoNodeTitle')}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      destroyOnClose
      data-testid="canvas-video-node-delete-modal"
    >
      <p style={{ margin: '0 0 12px', color: '#374151' }}>{t('board.deleteVideoNodeIntro')}</p>
      {assetCount > 1 ? (
        <p style={{ margin: '0 0 16px', color: '#6b7280', fontSize: 13 }}>
          {t('board.deleteVideoNodeAssetCount', { count: assetCount })}
        </p>
      ) : null}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <button
          type="button"
          className="pcv-action-popover-btn"
          style={{ width: '100%', textAlign: 'left', padding: '12px 14px', height: 'auto' }}
          disabled={busy}
          onClick={onRemoveNodeOnly}
          data-testid="canvas-video-delete-node-only"
        >
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('board.deleteVideoNodeOnlyTitle')}</div>
          <div style={{ fontSize: 13, color: '#6b7280' }}>{t('board.deleteVideoNodeOnlyDesc')}</div>
        </button>
        <button
          type="button"
          className="pcv-action-popover-btn pcv-action-popover-btn--primary"
          style={{
            width: '100%',
            textAlign: 'left',
            padding: '12px 14px',
            height: 'auto',
            borderColor: '#dc2626',
            background: '#fef2f2',
            color: '#b91c1c',
          }}
          disabled={busy}
          onClick={onRemoveNodeAndAssets}
          data-testid="canvas-video-delete-node-and-assets"
        >
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('board.deleteVideoNodeAndAssetsTitle')}</div>
          <div style={{ fontSize: 13, color: '#991b1b' }}>{t('board.deleteVideoNodeAndAssetsDesc')}</div>
        </button>
        <button type="button" className="pcv-action-popover-btn" style={{ width: '100%' }} disabled={busy} onClick={onCancel}>
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  )
}
